export const ApiEndpoints = {
    kpmgAdmin: {
        getAll: "/api/user/get-kpmg-admins",
        add: "/api/user/add-kpmg-admin",
        changeStatus: "/api/user/change-kpmg-admin-status",
        downloadReport: "/api/user/kpmg-admins-report"
    },
    kpmgClient: {
        getAll: "/api/client/get-clients",
        add: "/api/client/add-client",
        getClientsWithAvailableCompanies: "/api/client/get-clients-with-available-companies",
        get: (id) => `/api/client?id=${id}`,
        edit: (id) => `/api/client?id=${id}`,
        getClientDetailsWithAdmins: (id) => `api/client/get-client-details-with-admins?id=${id}`,
        delete: "/api/client",
        toggleClientStatus: "/api/client/change-client-active-status",
        getLogs: "/api/client/logs",
        resendInvitations: (clientId) => `/api/client/resend-client-users-invitations/${clientId}`,
        downloadReport: "/api/client/clients-report"
    },
    company: {
        getAll: "api/company/get-companies",
        get: (id) => `/api/company?id=${id}`,
        add: "/api/company/add-company",
        edit: (id) => `/api/company?id=${id}`,
        delete: "api/company",
        getClientsCompaniesAndRoles: "api/company/get-clients-companies-and-roles",
        getCalculationStartupDetails: "api/company/get-tax-calculation-startup-details",
        downloadReport: "/api/company/companies-report"
    },
    user: {
        getUserDetailsForDisplay: (id) => `api/user/get-user-details-for-display?id=${id}`,
        getUserDetailsForEdit: (id) => `api/user/get-user-details-for-edit?id=${id}`,
        edit: (id) => `api/user?id=${id}`,
        add: "/api/user/add-user",
        getAll: "/api/user/get-users",
        downloadReport: "/api/user/users-report"
    },
    account: {
        getUserAccessDetails: "/api/user/get-user-access-details"
    },
    calculation: {
        add: "/api/calculation/add-calculation",
        confirmSubmission: "/api/calculation/confirm-statement-submission",
        get: (id) => `/api/calculation?id=${id}`,
        getBalanceAccounts: (calculationId) => `/api/calculation/get-balance-accounts?calculationId=${calculationId}`,
        getAll: "/api/calculation/get-calculations",
        getStep: (calculationId, stepNumber) => `/api/calculation/get-calculation-step?id=${calculationId}&stepNo=${stepNumber}`,
        updateStepDetails: "/api/calculation/save-calculation-step",
        updateStatus: "/api/calculation/update-status",
        downloadReport: (calculationId) => `/api/calculation/download-report?id=${calculationId}`,
        setActiveUser: "/api/calculation/set-active-user",
        updateBalance: "/api/calculation/update-balance",
        updateCalculationFirstStep: "/api/calculation/update-calculation-first-step",
        downloadRecordBook: (calculationId) => `/api/calculation/download-record-book?calculationId=${calculationId}`,
        downloadBalance: (calculationId) => `/api/calculation/download-balance?calculationId=${calculationId}`,
        delete: (calculationId) => `/api/calculation/delete-calculation?id=${calculationId}`,
        getLogs: "/api/calculation/logs",
        downloadCalculationsReport: "/api/calculation/calculations-report"
    },
    document: {
        getDocuments: "/api/document/get-documents",
        getClientWithCompaniesAndStorage: "/api/document/get-clients-with-companies-and-storage",
        add: "/api/document/add-document",
        download: (documentId) => `/api/document/download?id=${documentId}`,
        getCalculationReusableDocuments: (calculationId, stepNumber) => `/api/document/get-reusable-documents-for-calculation?id=${calculationId}&stepNumber=${stepNumber}`,
        getDocumentDetailsWithCalculations: (documentId) => `/api/document/get-document-details-with-calculations?id=${documentId}`,
        delete: (documentId) => `/api/document/delete-document?id=${documentId}`,
        downloadReport: "/api/document/documents-report"
    },
    historicalModule: {
        getTemplate: (companyId) => `/api/historicalModule/get-historical-module-template?companyId=${companyId}`,
        add: "api/historicalModule/create-historical-module",
        update: "api/historicalModule/update-historical-module",
        getHistoricalModule: (companyId) => `/api/historicalModule/get-historical-module?companyId=${companyId}`
    },
    legislation: {
        getLegislationArticle: (id) => `/api/legislation?id=${id}`
    },
    staticFiles: "/files",
    notifications: {
        get: "api/notification/get-notifications",
        toggleRead: "api/notification/toggle-notification-read"
    },
    authorize: {
        exchangeAccessCode: "api/authorize/exchange-access-code",
        refreshToken: "api/authorize/refresh-access-token"
    }
};
